import React from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import { Button } from "../Button";

export const FileSelectButton = (props) => {
    const { onSelect, children, accept, busy, disabled, multiple } = props;
    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop: (files) => files?.length && onSelect(multiple ? files : files[0]),
        multiple,
        accept,
        disabled: disabled || busy,
        onClick: (evt) => evt.preventDefault()
    });

    return (
        <Button onClick={open} {...props}>
            {children}
            <div {...getRootProps()}>
                <input {...getInputProps()} />
            </div>
        </Button>
    );
};

FileSelectButton.defaultProps = {
    accept: {
        "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp"]
    },
    multiple: false
};

FileSelectButton.propTypes = {
    /**
     * Select file callback
     */
    onSelect: PropTypes.func,

    /**
     * Accept MIME-types
     * https://react-dropzone.js.org/#section-accepting-specific-file-types
     */
    accept: PropTypes.object,

    /**
     * Select multiple files
     */
    multiple: PropTypes.bool
};
